import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';


const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    z-index: 1000;
    left: ${displayState?.alignRight ? '' : '0'};
    right: ${displayState?.alignRight ? '100%' : ''};
    width: 100%;
    top: ${displayState?.showOnTop ? null : "48px"};
    bottom: ${displayState?.showOnTop ? "48px" : null};
  `}
`;

export default Wrapper(template);
